import { UPDATE_TASK_MANAGER_SELECTED_TASK } from "../constants/actionTypes"

function init(): any {
	return {
		selectedTask: {},
	}
}

export const taskManagerReducer = (state = init(), action: any): any => {
	switch (action.type) {
		case UPDATE_TASK_MANAGER_SELECTED_TASK:
			return Object.assign(state, { selectedTask: action.task })
		default:
			return state
	}
}
